import { FORM_ELEMENT_TYPES, FLOW_STATUS } from '../';
const isAfterSubmissionDate = (elementCreateDate, assignmentSubmissionDate) => {
    if (!assignmentSubmissionDate || !elementCreateDate)
        return false;
    const elementDate = new Date(elementCreateDate);
    const assignmentDate = new Date(assignmentSubmissionDate);
    if (elementDate.getFullYear() < 2000 || assignmentDate.getFullYear() < 2000)
        return false;
    return elementDate.getTime() > (assignmentDate.getTime() + 2 * 60 * 60 * 1000 + 5 * 60 * 1000);
};
export const transformForms = (flowStep, assignment, previewedData) => {
    const flowAssignment = flowStep?.assignments[assignment];
    const submitted = [
        FLOW_STATUS.SUBMITTED,
        FLOW_STATUS.APPROVED,
        FLOW_STATUS.CHANGES_REQUESTED,
        FLOW_STATUS.RESUBMITTED,
    ].includes(flowAssignment?.status || '');
    const submissionDate = flowAssignment?.submissionDate;
    const assignmentDatas = flowAssignment?.data || [];
    return flowStep.flow?.map((flowForm) => {
        return {
            ...flowForm,
            flow: flowForm.flow?.map(((formElement) => {
                if (isAfterSubmissionDate(formElement.createdAt, submissionDate) &&
                    !assignmentDatas.some((data) => data.flowElementId == formElement.id)) {
                    return {
                        ...formElement,
                        hidden: true,
                    };
                }
                if (formElement.elementType === FORM_ELEMENT_TYPES.GROUP) {
                    const groupInstanceElements = assignmentDatas.filter((data) => data.flowElementId == formElement.id);
                    const hiddenChilds = [];
                    let instances = groupInstanceElements.map((groupInstance) => {
                        const childInstances = formElement.flow?.map(((child, idx) => {
                            const foundData = assignmentDatas.find((data) => (data.flowElementId == child.id) && (data.dataGroupId == groupInstance.id) &&
                                (!data.input || data.input?.elementType !== FORM_ELEMENT_TYPES.GROUP));
                            if (!foundData && isAfterSubmissionDate(child.createdAt, submissionDate)) {
                                return {
                                    id: idx,
                                    flowElementId: child.id,
                                    assignmentId: flowStep.assignments[assignment]?.id,
                                    dataGroupId: groupInstance.id,
                                    dataGroup: { flowElementId: formElement.id },
                                    elementType: child.elementType,
                                    value: undefined,
                                    noData: true,
                                    hidden: true,
                                };
                            }
                            if (foundData) {
                                if (!submitted && child.config?.hidden)
                                    hiddenChilds.push(child.id);
                                return {
                                    ...foundData,
                                    title: submitted ? (foundData.input?.title || child.title) : child.title,
                                    elementType: foundData.input?.elementType,
                                    upload: foundData?.upload,
                                    isEditable: foundData?.isEditable,
                                    value: foundData.input?.elementType === FORM_ELEMENT_TYPES.MULTISELECT ||
                                        foundData.input?.elementType === FORM_ELEMENT_TYPES.MULTITEXT ?
                                        foundData.input?.values : foundData.input?.values[0],
                                };
                            }
                            else {
                                if (child.config?.hidden)
                                    hiddenChilds.push(child.id);
                                return {
                                    id: idx,
                                    flowElementId: child.id,
                                    assignmentId: flowStep.assignments[assignment]?.id,
                                    dataGroupId: groupInstance.id,
                                    dataGroup: { flowElementId: formElement.id },
                                    elementType: child.elementType,
                                    value: undefined,
                                    noData: true,
                                    hidden: child.config?.hidden,
                                };
                            }
                        }) || []).filter((child) => !child?.hidden);
                        return {
                            id: 0,
                            ...groupInstance,
                            value: groupInstance?.coi,
                            coi: groupInstance?.coi,
                            comment: groupInstance?.comment,
                            isEditable: groupInstance?.isEditable,
                            upload: groupInstance?.upload,
                            childInstances,
                        };
                    });
                    if (!instances.length)
                        instances = [{
                                id: 0,
                                flowElementId: formElement.id,
                                assignmentId: flowStep.assignments[assignment]?.id,
                                childInstances: formElement.flow?.map((child, idx) => ({
                                    id: idx,
                                    flowElementId: child.id,
                                    assignmentId: flowStep.assignments[assignment]?.id,
                                    dataGroup: { flowElementId: formElement.id },
                                    elementType: child.elementType,
                                    value: undefined,
                                    noData: true,
                                })) || [],
                            }];
                    return {
                        ...formElement,
                        flow: formElement.flow.filter((childEl) => !hiddenChilds.includes(childEl.id)),
                        hidden: formElement.config?.hidden && !groupInstanceElements.length,
                        instances,
                    };
                }
                else if (formElement.elementType === FORM_ELEMENT_TYPES.PREVIEW) {
                    const elementPreviewData = previewedData?.find((pd) => pd.previewElementId == formElement.id);
                    const previewItems = [];
                    if (elementPreviewData) {
                        const byAssignment = new Map();
                        elementPreviewData.data.forEach((d) => {
                            const existing = byAssignment.get(d.assignmentId) || [];
                            byAssignment.set(d.assignmentId, [...existing, d]);
                        });
                        byAssignment.forEach((datas, assignmentId) => {
                            const foundAssignment = flowStep.assignments.find((a) => a.id === assignmentId);
                            const owner = foundAssignment?.owner
                                ? `${foundAssignment.owner.firstName} ${foundAssignment.owner.lastName}`
                                : 'Assignment owner';
                            const childrenByGroupId = new Map();
                            const parentDatas = [];
                            datas.forEach((d) => {
                                if (d.dataGroupId != null) {
                                    const key = String(d.dataGroupId);
                                    childrenByGroupId.set(key, [...(childrenByGroupId.get(key) || []), d]);
                                }
                                else {
                                    parentDatas.push(d);
                                }
                            });
                            const parentsByFlowElementId = new Map();
                            const flowElementIdOrder = [];
                            parentDatas.forEach((d) => {
                                if (!parentsByFlowElementId.has(d.flowElementId)) {
                                    parentsByFlowElementId.set(d.flowElementId, []);
                                    flowElementIdOrder.push(d.flowElementId);
                                }
                                parentsByFlowElementId.get(d.flowElementId).push(d);
                            });
                            const loneIds = flowElementIdOrder.filter((fid) => (parentsByFlowElementId.get(fid) || []).every((d) => d.input?.elementType !== FORM_ELEMENT_TYPES.GROUP));
                            const groupIds = flowElementIdOrder.filter((fid) => (parentsByFlowElementId.get(fid) || []).some((d) => d.input?.elementType === FORM_ELEMENT_TYPES.GROUP));
                            const emittedGroupKeys = new Set();
                            const sortedDatas = [
                                ...[...loneIds, ...groupIds].flatMap((fid) => (parentsByFlowElementId.get(fid) || []).flatMap((d) => {
                                    if (d.id == null)
                                        return [d];
                                    const key = String(d.id);
                                    const children = childrenByGroupId.get(key) || [];
                                    if (children.length)
                                        emittedGroupKeys.add(key);
                                    return [d, ...children];
                                })),
                                ...Array.from(childrenByGroupId.entries())
                                    .filter(([key]) => !emittedGroupKeys.has(key))
                                    .sort(([a], [b]) => Number(a) - Number(b))
                                    .flatMap(([key, children]) => {
                                    const parent = children[0]?.dataGroup;
                                    const title = parent?.title || parent?.input?.title;
                                    if (!title)
                                        return children.map((c, idx) => idx === 0 ? { ...c, groupStart: true } : c);
                                    const header = {
                                        id: `group-${key}`,
                                        flowElementId: parent?.flowElementId,
                                        title,
                                        instanceNumber: parent?.instanceNumber,
                                        input: { title, elementType: FORM_ELEMENT_TYPES.GROUP, values: [] },
                                    };
                                    return [header, ...children];
                                }),
                            ];
                            const groupCounts = new Map();
                            previewItems.push({
                                owner,
                                status: foundAssignment?.status,
                                datas: sortedDatas.map((d) => {
                                    const isGroup = d.input?.elementType === FORM_ELEMENT_TYPES.GROUP;
                                    let name = d.flowElement?.title || d.title || String(d.flowElementId);
                                    if (isGroup) {
                                        const count = (groupCounts.get(d.flowElementId) || 0) + 1;
                                        groupCounts.set(d.flowElementId, count);
                                        name = `${name} #${d.instanceNumber || count}`;
                                    }
                                    return {
                                        id: d.id || '',
                                        name,
                                        element_type: d.input?.elementType || '',
                                        values: d.input?.values || [],
                                        groupStart: d.groupStart,
                                    };
                                }),
                            });
                        });
                    }
                    return { ...formElement, previewItems };
                }
                else {
                    const assignmentEl = assignmentDatas.find((data) => data.flowElementId == formElement.id);
                    if (!submitted && assignmentEl && formElement.config?.hidden) {
                        return {
                            ...formElement,
                            hidden: true,
                        };
                    }
                    if (assignmentEl)
                        return {
                            ...formElement,
                            title: submitted ? (assignmentEl.input?.title || formElement.title) : formElement.title,
                            upload: assignmentEl?.upload,
                            isEditable: assignmentEl?.isEditable,
                            value: formElement.elementType === FORM_ELEMENT_TYPES.MULTISELECT ||
                                formElement.elementType === FORM_ELEMENT_TYPES.MULTITEXT ?
                                assignmentEl.input?.values
                                : assignmentEl.input?.values[0],
                        };
                    else
                        return {
                            ...formElement,
                            hidden: formElement.config?.hidden,
                            value: undefined,
                            noData: true,
                        };
                }
            }) || []).filter((flowElement) => !flowElement?.hidden),
        };
    }) || [];
};
